<template>
  <div class="card border border-light-gray shadow-below-light cursor-pointer overflow-hidden relative flex-col flex rounded-2xl">
    <div
      class="card-media"
      :class="{ 'overflow-hidden': cardInfo.name || cardInfo.location || cardInfo.description }"
    >
      <ResponsiveImage
        class="card-image w-full h-[300px]"
        :image="cardInfo.cloudinary_image"
        :alt="buildAltText"
        align="center"
        gravity="auto"
        :skeleton="true"
        type="cloudinary"
      />
    </div>
    <div class="card-content flex flex-col p-3">
      <h5
        v-if="cardInfo.name"
        class="m-0"
      >
        {{ cardInfo.name }}
      </h5>
      <p
        v-if="cardInfo.location"
        class="m-0"
      >
        {{ cardInfo.location }}
      </p>
      <p
        v-if="cardInfo.description"
        class="m-0 card-description pt-2"
      >
        {{ cardInfo.description }}
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  cardInfo: {
    type: Object,
    default: () => ({}),
  },
  index: {
    type: Number,
    default: 0,
  },
})
const buildAltText = computed(() => {
  const name = props.cardInfo.name
  const location = props.cardInfo.location
  const index = props.index
  return `${name} - ${location} - image-${index}`
})
</script>

<style lang="scss" scoped>
.card {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
  }

  &:hover .card-description {
    display: block;
  }

  @media (min-width: theme('screens.md')) {
    width: 350px;
    height: 350px;
  }

  @media (max-width: calc(theme('screens.md') + 1)) {
    .card-description{
      transform: none;
      display: block !important;
    }
  }
}

.card-media {
  flex: 1 0 30%;
}

.card-content {
  p.card-description {
    display: none;
    font-size: 0.875rem;

    @media (max-width: theme('screens.sm')) {
      transform: none;
      display: block;
    }
  }
}
</style>